/**
 * 全局配置文件
 */
import {getTenantId} from '@/utils/auth'
export default {
  clientId: 'game', // 客户端id
  clientSecret: 'game_secret', // 客户端密钥
  tenantMode: true, // 是否开启租户模式
  tenantId: getTenantId(), // 管理组租户编号

  // 第三方系统授权地址
  authUrl: 'http://localhost/blade-auth/oauth/render',
  // 流程设计器地址
  flowDesignUrl: 'http://localhost:9999',
  // 报表设计器地址(cloud端口为8108,boot端口为80)
  reportUrl: 'http://localhost:8108/ureport'
}



// WEBPACK FOOTER //
// ./src/config/website.js